import React, { useEffect } from 'react';

import { Input, Select, Space } from 'antd';

type Category = { id: number; name: string; client_manager_id?: number | null };

type CategoryFilterProps = {
  categories: Category[];
  onFilterChange: (filteredCategories: Category[]) => void;
};

const CategoryFilter: React.FC<CategoryFilterProps> = ({ categories, onFilterChange }) => {

    const handleSearch = (value: string) => {
        const filtered = categories.filter((cat) =>
            cat.name.toLowerCase().includes(value.toLowerCase())
        );
        onFilterChange(filtered); 
    };

    const handleFilter = (value: string) => {
        const filtered = value === 'default'
            ? categories.filter((cat) => !cat.client_manager_id)
            : value === 'custom'
                ? categories.filter((cat) => cat.client_manager_id !== null)
                : categories;
        onFilterChange(filtered); 
    };

    useEffect(() => {
        onFilterChange(categories); 
    }, [categories, onFilterChange]);

    return (
        <Space>
            <Input.Search
                placeholder="Pesquisar"
                allowClear
                onChange={(e) => handleSearch(e.target.value)}
                style={{ width: 300 }}
            />
            <Select
                placeholder="Filtrar por tipo"
                allowClear
                options={[
                    { label: 'Padrão', value: 'default' },
                    { label: 'Customizada', value: 'custom' },
                ]}
                onChange={handleFilter}
                style={{ width: 200 }}
            />
        </Space>
    );
};

export default CategoryFilter;
